import React, { Component } from "react";
import { Link } from "react-router-dom";
class CityXTour_SiteContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div id="site-content" className="site-content clearfix">
        <div id="inner-content" className="inner-content-wrap">
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
          <div className="themesflat-row equalize sm-equalize-auto clearfix">
            <div className="span_1_of_6 bg-f7f">
              <div
                className="themesflat-spacer clearfix"
                data-desktop={60}
                data-mobile={60}
                data-smobile={60}
              />
              <div
                className="themesflat-content-box clearfix"
                data-margin="0 10px 0 43px"
                data-mobilemargin="0 15px 0 15px"
              >
                <div className="themesflat-headings style-2 clearfix">
                  <div className="sup-heading">ZA ISTINSKE PUTOLJUPCE</div>
                  <h2 className="heading font-size-28 line-height-39">
                    CITY<b>X</b> Tour &#38; Pass
                  </h2>
                  <div className="sep has-width w80 accent-bg margin-top-20 clearfix" />
                  <p className="sub-heading margin-top-33 line-height-24">
                    CityX Tour&#38;Pass nova je digitalna platforma koja turiste
                    povezuje s turističkim atrakcijama, događanjima i uslugama
                    unutar mreže CityX gradova, a namijenjena je upravo tebi,
                    zaljubljeniku u putovanja, koji svoje destinacije i prateće
                    sadržaje pronalazi, odabire, rezervira i plaća putem
                    aplikacija.
                  </p>
                </div>
              </div>
              <div
                className="themesflat-spacer clearfix"
                data-desktop={56}
                data-mobile={56}
                data-smobile={56}
              />
            </div>
            <div
              className="span_1_of_6 half-background "
              style={{
                backgroundImage: "url(../assets/img/apps/cityx-tour-pass.jpg",
              }}
            ></div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={39}
            data-mobile={39}
            data-smobile={39}
          />
          <div className="flat-content-wrap style-2 clearfix">
            <h5 className="title">KAKO FUNKCINIORA CITYX TOUR &#38; PASS?</h5>
            <p>
              U City<b>X</b> mrežu trenutno je uključeno dvadeset gradova.
              Klikom na destinaciju na kojoj trenutno jesi, ili želiš ići,
              ponudit će ti se izbor lokalnih vodiča, najzanimljivih atrakcija
              (muzeji, galerije i sl.), dodatnih sadržaja koji su dostupni u
              gradu i okolici, kao i mjesta na kojima možeš probati lokalne
              delicije, tj. sve što je potrebno kako bi ti odmor bio i
              edukativan i zanimljiv i- uzbudljiv!
            </p>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={37}
            data-mobile={35}
            data-smobile={35}
          />
          <div className="flat-content-wrap style-2 clearfix">
            <div className="item">
              <div className="inner">
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={10}
                  data-mobile={10}
                  data-smobile={10}
                />
                <h5 className="title">CITYX TOUR &#38; PASS uključuje:</h5>
                <p></p>
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={8}
                  data-mobile={8}
                  data-smobile={8}
                />
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">
                        Popis vodiča na ciljanoj lokaciji + rezervaciju
                        tura/turi
                      </span>
                    </span>
                  </div>
                </div>
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">
                        Pregled atrakcija + online kupovinu ulaznica
                      </span>
                    </span>
                  </div>
                </div>
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">
                        Izbor restorana u kojima imaš osiguran popust
                      </span>
                    </span>
                  </div>
                </div>
                <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                  <div className="inner">
                    <span className="item">
                      <span className="icon">
                        <i className="fa fa-check-circle" />
                      </span>
                      <span className="text">Popis suvenirnica</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={37}
            data-mobile={35}
            data-smobile={35}
          />
        </div>
      </div>
    );
  }
}

export default CityXTour_SiteContent;
